import { Injectable } from "@angular/core";
import { FirebaseCrashlytics, RecordExceptionOptions } from '@capacitor-firebase/crashlytics';
import { logger } from "src/app/common/services/logging/logging.service";
import { PlatformService } from "./platform.service";

@Injectable({
    providedIn: 'root'
})
export class CrashlyticsService {

    constructor(
    ) { }

    /**
     * Initialize Firebase Crashlytics
     */
    public init() {

        if (PlatformService.isBrowser()) return;

        // Nothing to init as it is initialized inside Xcode / Gradle directly
        // https://www.npmjs.com/package/@capacitor-firebase/crashlytics

        CrashlyticsService.enable().then(() => {
            logger.info('Crashlytics enabled');
        })
        .catch((error) => {
            logger.error('Crashlytics enable error', error);
        });
    }

    public static async enable(): Promise<void> {
        await FirebaseCrashlytics.setEnabled({ enabled: true });
    }

    public static async disable(): Promise<void> {
        await FirebaseCrashlytics.setEnabled({ enabled: false });
    }

    public static async isEnabled(): Promise<boolean> {
        const result = await FirebaseCrashlytics.isEnabled();
        return result.enabled;
    }

    // Simulated Crash Event for testing
    public static async crash(message: string = 'Simulated Crash Event'): Promise<void> {
        let crashOptions = {
            message: message
        };
        await FirebaseCrashlytics.crash(crashOptions);
    }

    public static async recordException(options: RecordExceptionOptions): Promise<void> {
        await FirebaseCrashlytics.recordException(options);
    }
}

